<template>
  <div class="Layout">
    <a :href="pnBaseUri" target="_blank" class="Layout__logo">
      <img src="@setl/ui/src/images/logo/pn.svg"
           alt="Логотип ПН"
           class="Layout__image"
      />
    </a>
    <div class="Layout__body">
      <RouterView />
      <Preloader v-if="isLoading" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useHead } from '@unhead/vue';
  import { computed, ref, watch } from 'vue';
  import { useStore } from 'vuex';
  import { Preloader, usePreloader } from '@pn/vue-ui';

  useHead({
    titleTemplate: '%s - Партнёрский портал',
  });

  const pnBaseUri = ref(String(import.meta.env.VITE_PN_BASE_URI));
  const { isLoading, setLoading } = usePreloader();
  const store = useStore();
  const showSpinner = computed(() => store.state.showSpinner);

  watch(showSpinner, (nextValue) => {
    setLoading(nextValue ?? false);
  });
</script>

<style lang="scss">
  @import '@/assets/scss/variables';
  @import '@/assets/scss/mixins';

  .Layout {
    @include container();

    min-width: 320px;
    padding-top: 80px;

    &__logo {
      position: relative;
      display: block;
      width: 222px;
      height: 0;
      margin: 0 auto;
      padding-bottom: 50px;
    }

    &__image {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
